import React, { useState, useEffect } from "react";
import "./useThemeSwitcher.scss";

function useThemeSwitcher() {
  const [mode, setMode] = useState(() => localStorage.getItem("mode"));

  useEffect(() => {
    window.addEventListener("storage", setPreferedTheme);
    return () => {
      window.removeEventListener("storage", setPreferedTheme);
    };
  }, []);

  const setPreferedTheme = () => {
    const _mode = localStorage.getItem("mode");
    if (_mode) {
      setMode(_mode);
    } else {
      setMode("light");
    }
  };

  useEffect(() => {
    if (mode === "dark") {
      document.body.classList.add("dark-mode");
      localStorage.setItem("mode", "dark");
    } else {
      document.body.classList.remove("dark-mode");
      localStorage.setItem("mode", "light");
    }
  }, [mode]);

  return (
    <div className="container">
      <span className="light-icon-footer">☀︎</span>
      <div className="switch-checkbox">
        <label className="switch">
          <input
            type="checkbox"
            onChange={() =>
              setMode((mode) => (mode === "dark" ? "light" : "dark"))
            }
          />
          <span className="slider round"> </span>
        </label>
      </div>
      <span className="dark-icon-footer">☽</span>
    </div>
  );
}

export default useThemeSwitcher;
